import axios from "axios"
import baseUrl from "./base"

const layananApi = {
  fetchLayananByPaket: async (token, id_paket) => {
    return await axios.get(`${baseUrl}/api/layanan/get?id_paket=${id_paket}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchLayananByPaketPublic: async (token, slug) => {
    return await axios.get(`${baseUrl}/api/layanan/getPublic?slug_paket=${slug}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showLayananPublic: async (token, slug) => {
    return await axios.get(`${baseUrl}/api/layanan/${slug}/showPublic`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchAllLayanan: async (token, data) => {
    return await axios.get(`${baseUrl}/api/layanan/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeLayanan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/layanan/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateLayanan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/layanan/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusLayanan: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/layanan/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateLayananDokumen: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/layanan/${id}/updateLayananDokumen`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeLayananDokumen: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/layanan/${id}/storeLayananDokumen`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteLayananDokumen: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/layanan/${id}/deleteLayananDokumen`, data, // data = request->id_layanan_dokumen
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  uploadContohForm: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/layanan/${id}/uploadContohForm`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  }
}

export default layananApi